import { Injectable } from '@angular/core';
import { concatLatestFrom } from '@ngrx/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';
import * as V2StandardteksterActions from './v2-standardtekster.actions';
import { V2StandardteksterSelectors, V2StandardteksterService } from './services';

@Injectable()
export class V2StandardteksterEffects {

    checkForLoadV2Standardtekster$ = createEffect(() => this.actions$.pipe(
        ofType(V2StandardteksterActions.checkForLoadV2Standardtekster),
        concatLatestFrom(() => [
            this.v2StandardteksterSelector.loaded$,
            this.v2StandardteksterSelector.loading$
        ]),
        map(([_, loaded, loading]) => {
            if (!loading && !loaded) {
                return V2StandardteksterActions.loadV2Standardtekster();
            }
            return V2StandardteksterActions.noLoadV2Standardtekster();
        })
    ));

    loadV2Standardtekster$ = createEffect(() => this.actions$.pipe(
        ofType(V2StandardteksterActions.loadV2Standardtekster),
        switchMap(() => this.v2StandardteksterService.getV2Standardtekster().pipe(
                map(v2Standardtekster => V2StandardteksterActions.loadV2StandardteksterSuccess({ v2Standardtekster }))
        ))
    ));

    constructor(
        private actions$: Actions,
        private v2StandardteksterService: V2StandardteksterService,
        private v2StandardteksterSelector: V2StandardteksterSelectors,
    ) {}

}
